import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">
          &copy; {currentYear} Pool Tournament Manager. All rights reserved.
        </p>
        <div className="footer-links">
          <a
            href="https://www.blackball.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Official UK Blackball Rules
          </a>
          <a
            href="https://porkenpence.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Website by Porkenpence Ltd
          </a>
        </div>
      </div>
    </footer>
  );
}
